import React from "react";
import styled from "@emotion/styled";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";
import { ProductQnACard } from "@pages/product/_components/index";

const List = styled.div({
  display: "flex",
  flexDirection: "column",
});

type Props = {
  productId: number;
  selectedQnaId: number | null;
  setSelectedQnaId: React.Dispatch<React.SetStateAction<null | number>>;
};
const ProductQnAList = ({
  productId,
  selectedQnaId,
  setSelectedQnaId,
}: Props) => {
  const { getProductQnaList } = useApiRequest();

  const { data: productQnaList } = useQuery({
    queryKey: ["productQnaList", productId],
    queryFn: () => getProductQnaList(Number(productId)),
    enabled: !!productId,
  });

  return (
    <List>
      {productQnaList?.map((item: any) => (
        <ProductQnACard
          key={item.qna_id}
          options={item}
          selectedQnaId={selectedQnaId}
          setSelectedQnaId={setSelectedQnaId}
        />
      ))}
    </List>
  );
};

export default ProductQnAList;
